import React from 'react';
import styled from 'styles/styled-components';
import translations from 'translations';
import { SparkleIcon } from './icons';
import messages from './messages';

interface ResultBannerProps {
  found: number;
  total: number;
  hasHigh: boolean;
  onSelectAllHigh: () => void;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0faf1 0%, #e6f9e7 100%);
  gap: 16px;
  border: 1px solid #c6f3c9;

  @media (max-width: 767px) {
    padding: 8px;
    align-items: flex-start;
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  line-height: 24px;
  color: #111827;

  & > svg {
    flex-shrink: 0;
  }
`;

const SelectAllBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #3c9041;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const ResultBanner = ({ found, total, hasHigh, onSelectAllHigh }: ResultBannerProps) => {
  const text = translations(messages.resultBanner).replace('{found}', String(found)).replace('{total}', String(total));
  return (
    <Wrapper>
      <Left>
        <SparkleIcon />
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </Left>
      {hasHigh && (
        <SelectAllBtn type="button" onClick={onSelectAllHigh}>
          {translations(messages.selectAllHighConfidence)}
        </SelectAllBtn>
      )}
    </Wrapper>
  );
};

export default ResultBanner;
